module.exports = __webpack_public_path__ + "static/media/Layout20.1bdbd7d8.png";